(function () {
  function heartSVG(filled) {
    if (filled) {
      return '<svg width="20" height="20" viewBox="0 0 24 24" fill="#e00" stroke="#e00" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    }
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  function updateWishlistBadge() {
    window._swat.fetch(function (products) {
      var count = (products || []).length;
      var bubble = document.getElementById('wishlist-bubble');
      var countEl = document.getElementById('wishlist-count');
      if (bubble && countEl) {
        countEl.textContent = count;
        bubble.style.display = count > 0 ? 'flex' : 'none';
      }
    });
  }

  function injectWishlistButtons() {
    var cards = document.querySelectorAll('custom-product-card');
    if (!cards.length) return;

    window._swat.fetch(function (wishlistItems) {
      var wishlistedIds = (wishlistItems || []).map(function (p) {
        return String(p.empi);
      });

      cards.forEach(function (card) {
        var info = card.querySelector('.cpc__info');
        if (!info) return;
        if (info.querySelector('.swym-heart-btn')) return;

        var imgLink = card.querySelector('.cpc__img-link');
        var href = imgLink ? imgLink.getAttribute('href') : '';
        var handle = (href || '').split('/products/')[1];
        if (!handle) return;
        handle = handle.split('?')[0].split('#')[0];

        fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (prod) {
            var isFilled = wishlistedIds.includes(String(prod.id));

            var btn = document.createElement('button');
            btn.className = 'swym-heart-btn';
            btn.setAttribute('type', 'button');
            btn.setAttribute('aria-label', isFilled ? 'Remove from wishlist' : 'Add to wishlist');
            btn.innerHTML = heartSVG(isFilled);
            if (isFilled) btn.classList.add('swym-heart-filled');

            info.style.position = 'relative';
            btn.style.cssText =
              'position:absolute;top:-1.75rem;right:8px;background:white;border:none;border-radius:50%;cursor:pointer;padding:6px;line-height:1;z-index:5;box-shadow:0 2px 6px rgba(0,0,0,0.15);';

            info.appendChild(btn);

            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var variants = prod.variants || [];
              var variant = variants[0] || {};
              var isNowFilled = btn.classList.contains('swym-heart-filled');

              if (isNowFilled) {
                window._swat.removeFromWishList(
                  {
                    empi: prod.id,
                    epi: variant.id,
                    du: window.location.origin + '/products/' + handle,
                  },
                  function () {
                    btn.classList.remove('swym-heart-filled');
                    btn.innerHTML = heartSVG(false);
                    btn.setAttribute('aria-label', 'Add to wishlist');
                    updateWishlistBadge();
                  }
                );
              } else {
                window._swat.addToWishList(
                  {
                    empi: prod.id,
                    epi: variant.id,
                    du: window.location.origin + '/products/' + handle,
                    iu: prod.images && prod.images[0] ? prod.images[0] : '',
                    dt: prod.title,
                    pr: prod.variants && prod.variants[0] ? prod.variants[0].price / 100 : 0,
                  },
                  function () {
                    btn.classList.add('swym-heart-filled');
                    btn.innerHTML = heartSVG(true);
                    btn.setAttribute('aria-label', 'Remove from wishlist');
                    updateWishlistBadge();
                  }
                );
              }
            });
          });
      });
    });
  }

  function init() {
    if (window._swat) {
      injectWishlistButtons();
      updateWishlistBadge();
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function () {
        injectWishlistButtons();
        updateWishlistBadge();
      });
    }
  }

  setTimeout(init, 1500);
})();
